import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IEventTeacherItem } from '../../../../../Models/Event/IEventTeacherItem';
import { TeachersListView } from './TeachersListView';
import * as Services from '../../../../../Services/Services';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';
import { DefaultButton, Dialog, DialogFooter, DialogType, MessageBarType, PrimaryButton } from '@fluentui/react';
import { IAddEventTeacher } from '../../../../../Models/Event/IAddEventTeacher';
import { IUpdateEventTeacher } from '../../../../../Models/Event/IUpdateEventTeacher';
import { AddTeacherToEvent } from '../TeacherProperties/AddTeacherToEvent';
import { EditTeacherProperties } from '../TeacherProperties/EditTeacherProperties';

interface ITeachersListProps {
    eventId: number;
}


export const TeachersList: React.FunctionComponent<ITeachersListProps> = (props) => {
    const [isLoading, setIsLoading] = useBoolean(false);
    const [selectedTeacher, setSelectedTeacher] = React.useState<IEventTeacherItem>();
    const [teachers, setTeachers] = React.useState<IEventTeacherItem[]>([]);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isAddTeacherOpened, setIsAddTeacherOpened] = useBoolean(false);
    const [isUpdateTeacherOpened, setIsUpdateTeacherOpened] = useBoolean(false);
    const [isDeleteTeacherOpened, setIsDeleteTeacherOpened] = useBoolean(false);
    const [teacherToDelete, setTeacherToDelete] = React.useState(0);
    const loadData = async (eventId: number) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const eventType = await eventTypeApi.getEventTeachers(eventId);

        if (eventType.isSuccess && eventType.data) {
            setTeachers(eventType.data);
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }
 

    const deleteTeacher = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const eventType = await eventTypeApi.removeEventTeacher(props.eventId, teacherToDelete)
        if (eventType.isSuccess && eventType.data) {
            await loadData(props.eventId);
            setIsDeleteTeacherOpened.setFalse();
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();

    }
    const showDeleteTeacher = (teacherId: number) => {
        setIsDeleteTeacherOpened.setTrue();
        setTeacherToDelete(teacherId);
    }
 
    const showUpdateTeacherDialog = (teacher: IEventTeacherItem) => {
        setSelectedTeacher(teacher);
        setIsUpdateTeacherOpened.setTrue();
    }

    React.useEffect(() => {
        loadData(props.eventId);

    }, [props.eventId])


    return (<>
        <TeachersListView
            addNewTeacher={setIsAddTeacherOpened.setTrue}
            updateTeacher={showUpdateTeacherDialog}
            deleteTeacher={showDeleteTeacher}
            statusMessage={statusMessage} isLoading={isLoading} selectItem={setSelectedTeacher} items={teachers} />
        <AddTeacherToEvent eventId={props.eventId} isOpened={isAddTeacherOpened} onDismiss={setIsAddTeacherOpened.setFalse} refresh={(id) => loadData(id)} />
        <EditTeacherProperties teacher={selectedTeacher} eventId={props.eventId} isOpened={isUpdateTeacherOpened} onDismiss={setIsUpdateTeacherOpened.setFalse} refresh={(id) => loadData(id)} />
        <Dialog
            hidden={!isDeleteTeacherOpened}
            onDismiss={setIsDeleteTeacherOpened.setFalse}
            dialogContentProps={{
                type: DialogType.normal,
                title: "Odstranění lektora z události",
                subText:"Opravdu ostranit vybraného lektora"
            }}
            modalProps={{ isBlocking: true }}>
            <DialogFooter>
                <PrimaryButton onClick={deleteTeacher} text="Odstranit" />
                <DefaultButton onClick={setIsDeleteTeacherOpened.setFalse} text="Zavřít" />
            </DialogFooter>
        </Dialog>

        </>)

}
